const OperationsOnReservation = {
    PAY: 'Pay',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    ABANDON: 'Abandon',
    POSTPONE: 'Postpone'
}
export{OperationsOnReservation}